import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Http } from "../../../../../../helpers/axois";
import { useToast } from "../../../../../../helpers/commonFunction";
import {
  saveAsset,
  cancelEditAsset,
} from "../../../../../../stateManager/store/assets/action";
import Card from "../Card";
import { Button } from "../../../../../../helpers/commonUi";
import { encodeBase64, deleteFields } from "../../../../../../helpers/commonFunction";
import "./assetTab.scss";

const AssetTab = (props: any) => {
  const dispatch = useDispatch();
  const assets = useSelector((state: any) => state.assets.list);
  const orgId = useSelector((state: any) => state.org.selectedOrg.id);
  const selectedAssetId = useSelector(
    (state: any) => state.assets.selectedAssetId
  );
  const selectedAsset = assets[selectedAssetId] && assets[selectedAssetId].json;
  const { ErrorToast, SuccessToast } = useToast();

  const handleSaveAsset = () => {
    const data = assets[selectedAssetId];

    if (data.json.fields) {
      deleteFields(data.json.fields, ["editBind"])
    }

    const payload = {
      assetId: selectedAssetId,
      label: data.label,
      source: encodeBase64(JSON.stringify(data.json))
    }
    if (data.id) {
      Http.put(`orgs/${orgId}/assets/${data.id}`, payload).subscribe((_res) => {
        SuccessToast("Asset updated");
      }, (_err) => {
        ErrorToast("Unable to update asset")
      })
    }
    dispatch(saveAsset());
  }

  const handleCancelAsset = () => {
    dispatch(cancelEditAsset());
  };

  useEffect(() => {
    return () => {
      dispatch(saveAsset());
    }
  }, [dispatch])

  return (
    <div className="assetTab">
      <div className="header">
        <h1>Edit Asset</h1>
        <div className="actions">
          <Button
            dataTestId="save"
            color="primary"
            size="extra-small"
            onClick={handleSaveAsset}
          >
            SAVE
          </Button>
          <Button
            dataTestId="cancel"
            color="primary"
            size="extra-small"
            onClick={handleCancelAsset}
          >
            CANCEL
          </Button>
        </div>
      </div>

      {selectedAsset && (
        <Card
          id={selectedAsset.id}
          canEdit={props.canEdit}
          name={selectedAsset.label}
          JsonData={selectedAsset}
          isAsset={true}
          assetId={selectedAssetId}
          assetRoot={true}
        />
      )}
    </div>
  );
};

export default AssetTab;
